import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { coreLibraryInitialised } from "@glamcorner/core-cf-lib/lib/common/gcsession/utils";
import { StylePageEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import { useDesignations } from "../../context/DesignationProvider";
import { useURLParameter } from "../../context/URLParametersProvider";
import { useRental } from "../../context/RentalProvider";
import { useStyle } from "../../context/StyleProvider";
import { Bus } from "../../../services/Bus";
import { StyleDesignations } from "../../../../common/interfaces";

// Dumpling place for all the code that has to make contact with things "outside" the React container
export const MagentoIntegrationContainer: React.FC = () => {
  const { retailPriceInCents, buyInformation, rentalInformation, style } = useStyle();
  const { productCode, designation, allAvailableDesignations } = useDesignations();
  const { rentalPeriod } = useRental();
  const { bodyShape, rentalDates } = useURLParameter();

  useEffect(() => {
    // Pulled from ProductPage in Magento. We don't have all the information though
    Bus.broadcast(StylePageEvents.PageFinishedLoading, {
      id: style.style_code,
      style: style.style_code,
      name: style.name,
      price: "", // Could be multiple
      brand: style.designer,
      category: undefined, // Don't have access, only have category ID, not the string, eg: "Clothing",
      size_product_ids: [], // These  are magento product IDs for sizes
      is_rental: allAvailableDesignations.includes(StyleDesignations.RENTAL),
      is_ex_rental: undefined, // Not applicable anymore
      isClearanceItem: allAvailableDesignations.includes(StyleDesignations.BUY),
      rental_dates: {
        start_date: rentalDates?.startDate || null,
        end_date: rentalDates?.endDate || null,
      },
      quantity: 1,
      // Magento pade treated on-demand and buy the same way
      variant: designation === StyleDesignations.SUBSCRIPTION ? "subscription" : "on-demand",
      rentalDatesRange: undefined,
      rentalDaysInAdvance: undefined,
      size: undefined,
    });
  }, []);

  // --------- THUMBNAILS ---------
  useEffect(() => {
    if (coreLibraryInitialised()) {
      // Must call for thumbnails to show up
      GC.util.waitFor(
        () => !!GC.productPage,
        () => GC.productPage.changeImages(undefined, undefined)
      );
    }
  }, []);

  useEffect(() => {
    if (coreLibraryInitialised()) {
      // We want to persist the bump-friendly model pictures if present
      // Don't replace with plus size model on size select change
      if (bodyShape || productCode) {
        GC.util.waitFor(
          () => !!GC.productPage,
          () => {
            if (bodyShape === "Bump Friendly") {
              GC.productPage.changeImages("body_shape", bodyShape);
            } else if (productCode) {
              // TODO: extract
              GC.productPage.changeImages("size", productCode.split("--")[1]);
            }
          }
        );
      }
    }
  }, [productCode, bodyShape]);

  // --------- PRICES ---------
  // Currently the blocks that magento renders are a bit wack
  // It's impossible to go between products tact are on discount and ones that are not
  // So we replace the whole thing with something that looks exactly like the magento code
  // BUT this also sets us up for having easier time if we move the whole style page rendering here
  // Because all of the context hooks and data flow is already set up
  useEffect(() => {
    const prices = window.document.querySelector<HTMLSpanElement>("span.js-prices");

    if (!prices) {
      console.warn("could not find the price block");
      return;
    }

    import("../../components/MagentoPrices").then((mod) => {
      const MagentoMainPrice = mod.MagentoMainPrice;

      const rentalPrices = rentalInformation?.prices.find((price) => price.rentalDays === rentalPeriod);

      ReactDOM.render(
        <MagentoMainPrice
          retailPriceInCents={retailPriceInCents}
          designation={designation}
          rentalPrices={rentalPrices}
          buyPrices={buyInformation?.prices}
        />,
        prices
      );
    });
  }, [designation, rentalPeriod, retailPriceInCents, buyInformation, rentalInformation, style]);

  return <></>;
};
